export default __webpack_public_path__ + "static/media/element_31.f3e7b3f6.webp";